import createBrowserHistory from "history/createBrowserHistory";
import { QueryParser } from "../QueryParser";
export class BrowserHistoryAdapter {
    /**
     * @param options
     */
    constructor(options = {}) {
        this.history = createBrowserHistory(options);
    }
    /**
     * @param callback
     * @return {UnregisterCallback}
     */
    start(callback) {
        const unlisten = this.history.listen((location) => {
            callback(location.pathname, QueryParser.toObject(location.search));
        });
        callback(this.history.location.pathname, QueryParser.toObject(this.history.location.search));
        return unlisten;
    }
    /**
     * @param url
     */
    navigate(url) {
        this.history.push(url);
    }
}
